<div class="my-2">
  @if (!loading) {
    <div [class.compact]="compactClientView">
      @if (verificationsOrOptions.length > 0 || showAddForm) {
        <table
          [formGroup]="formGroup"
          class="table table-sm"
          >
          <thead [ngClass]="{ 'table-dark': dark }">
            <tr>
              <th>Referral Date</th>
              <th>
                @if (compactClientView) {
                  Referral Type
                }
                @if (!compactClientView) {
                  Evidence Type
                }
              </th>
              <th>Referral Notes</th>
              <th>Prescriber</th>
              <th>Specialty</th>
              @if (!compactClientView) {
                <th>Date Found</th>
              }
              @if (!compactClientView) {
                <th>Found By</th>
              }
              @if (!compactClientView) {
                <th>Note To Client</th>
              }
              @if (!compactClientView) {
                <th>&nbsp;</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (item of verificationsOrOptions; track item; let i = $index) {
              <ng-container
                formArrayName="options"
                >
                <ng-container>
                  <tr [class.selected]="option(item)?.selected">
                    <td>
                      @if (option(item)) {
                        <label>
                          <input type="checkbox" class="form-check-input" [formControlName]="i" />
                          {{ verification(item).referralDate | date: 'MM/dd/yyyy' }}
                        </label>
                      }
                      @if (!option(item)) {
                        <div>
                          {{ verification(item).referralDate | date: 'MM/dd/yyyy' }}
                        </div>
                      }
                    </td>
                    <td>
                      {{ verification(item).reasons | referralVerificationReasonShortNames | joinList }}
                    </td>
                    <td class="phi">
                      {{ verification(item).otherReason | blankValueDash }}
                    </td>
                    <td>
                      <div>{{ verification(item).provider?.fullName }}</div>
                      <div>NPI: {{ verification(item).provider?.npi }}</div>
                      <div><app-specialty-badges [specialties]="verification(item).provider?.specialties" /></div>
                    </td>
                    <td>
                      {{ verification(item).referralSpecialty | blankValueDash }}
                    </td>
                    @if (!compactClientView) {
                      <td>
                        {{ verification(item).createdAt | date: 'MM/dd/yyyy' }}
                      </td>
                    }
                    @if (!compactClientView) {
                      <td>
                        {{ verification(item).user?.fullName | blankValueDash }}
                      </td>
                    }
                    @if (!compactClientView) {
                      <td class="phi">
                        {{ verification(item).notes | blankValueDash }}
                      </td>
                    }
                    @if (!compactClientView) {
                      <td>
                        <a href="#"
                          (click)="onEditClick($event, verification(item).id)"
                          [class.invisible]="optionEditable(option(item))">
                          Edit
                        </a>
                      </td>
                    }
                  </tr>
                </ng-container>
                @if (editingId === verification(item).id) {
                  <tr class="edit-row">
                    <td colspan="99" class="px-2">
                      <app-ehr-referral-verification-form
                        [patientPrescriber]="patientPrescriber"
                        [provider]="provider"
                        [ehrReferralVerification]="verification(item)"
                        (canceled)="onEditCanceled()"
                        (saved)="onEditSave($event)" />
                    </td>
                  </tr>
                }
              </ng-container>
            }
            @if (showAddForm) {
              <tr>
                <td colspan="99">
                  <app-ehr-referral-verification-form
                    [patientPrescriber]="patientPrescriber"
                    [provider]="provider"
                    (canceled)="onAddCanceled()"
                    (saved)="onAddSave($event)" />
                </td>
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <div class="my-2">Patient has no applicable referral evidence.</div>
      }
    </div>
  } @else {
    <div class="mt-1 mb-2 ms-1"><mat-spinner diameter="30" /></div>
  }

  @if (editable && !showAddForm && !editingId) {
    <button
      class="btn btn-sm btn-secondary mt-1"
      (click)="onAddClick()"
      >
      Add Referral Evidence
    </button>
  }

</div>


